import * as yup from 'yup'

export const yupEmail = (t) =>
  yup.string().email().label(t('common:email'))
